import React from 'react';
import { KRWFomatToString, KRWFomatWithoutWon, Marginer, TextComponent, AlertComponent, XScrollableTable } from 'renderer/components';
import { TICKET_STATUS } from 'renderer/models';
import { PaymentHistoryQuery } from 'renderer/queries';
import { groupBy, sum, isString, floor } from 'renderer/utils';
import { TICKET_TYPE } from 'renderer/models';
import dayjs from 'dayjs';
import { COLORS } from 'renderer/styles';
export var StatTicket = function (props) {
    var _a, _b, _c, _d;
    var storeId = (_a = props.store) === null || _a === void 0 ? void 0 : _a.id;
    var stat = PaymentHistoryQuery.useTicketStatistics({ storeId: storeId }, { enabled: !!storeId });
    var getData = function () {
        if (stat.data) {
            // const prepaid = {
            //   created: (stat.data.prepaid?.created && Number(stat.data.prepaid?.created)) || 0,
            //   expired: (stat.data.prepaid?.expired && Number(stat.data.prepaid?.expired)) || 0,
            //   used: (stat.data.prepaid?.used && Number(stat.data.prepaid?.used)) || 0,
            //   groupName: '선불충전액',
            //   type: '',
            //   name: '-',
            //   amountOfSales: '-',
            //   breakageIncome: undefined
            // };
            // 활성화,사용완료, 사용기간 만료 정기권만을 대상으로 합
            var targetTicket = stat.data.tickets.filter(function (item) {
                return [TICKET_STATUS.EXPIRED, TICKET_STATUS.ACTIVE, TICKET_STATUS.COMPLETE].includes(item.status);
            });
            var grouped_1 = groupBy(targetTicket, 'copiedTicketTemplate.id');
            var refinedData_1 = Object.keys(grouped_1).map(function (templateId) {
                var _a, _b;
                var ticketsByTempateId = grouped_1[templateId];
                var fistTicket = ticketsByTempateId[0];
                var name = fistTicket.name;
                var groupName = '정기권';
                var type = (_a = fistTicket.copiedTicketTemplate) === null || _a === void 0 ? void 0 : _a.getTypeToString();
                var amountOfSales = ticketsByTempateId.length || 0;
                var created = sum(ticketsByTempateId.map(function (item) {
                    var _a, _b;
                    if (((_a = item.copiedTicketTemplate) === null || _a === void 0 ? void 0 : _a.type) === TICKET_TYPE.TERM) {
                        var _c = item.data, startedAt = _c.startedAt, expiredAt = _c.expiredAt;
                        if (startedAt && expiredAt) {
                            return dayjs(expiredAt).diff(startedAt, 'day');
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return Number(((_b = item.data) === null || _b === void 0 ? void 0 : _b.total) || 0);
                    }
                }));
                var used = sum(ticketsByTempateId.map(function (item) {
                    var _a, _b, _c;
                    if (((_a = item.copiedTicketTemplate) === null || _a === void 0 ? void 0 : _a.type) === TICKET_TYPE.TERM) {
                        var _d = item.data, startedAt = _d.startedAt, expiredAt = _d.expiredAt;
                        if (startedAt && expiredAt) {
                            var now = new Date();
                            var targetDate = now.getTime() > dayjs(expiredAt).toDate().getTime() ? expiredAt : now;
                            return dayjs(targetDate).diff(startedAt, 'day');
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return Number(((_b = item.data) === null || _b === void 0 ? void 0 : _b.total) || 0) - Number(((_c = item.data) === null || _c === void 0 ? void 0 : _c.remain) || 0);
                        if (item.status !== TICKET_STATUS.EXPIRED) {
                        }
                        else {
                            return 0;
                        }
                    }
                }));
                var expired = sum(ticketsByTempateId
                    .filter(function (item) { var _a; return (item.status === TICKET_STATUS.EXPIRED && Number(((_a = item.data) === null || _a === void 0 ? void 0 : _a.remain) || 0)) || 0; })
                    .map(function (item) { var _a; return ((_a = item.data) === null || _a === void 0 ? void 0 : _a.remain) || 0; }));
                var ticketPrice = sum(ticketsByTempateId.map(function (item) {
                    var _a;
                    return Number(((_a = item.copiedTicketTemplate) === null || _a === void 0 ? void 0 : _a.totalPrice) || 0);
                }));
                var breakageIncome = ((_b = fistTicket.copiedTicketTemplate) === null || _b === void 0 ? void 0 : _b.type) !== TICKET_TYPE.CHARGING_MONEY
                    ? floor((ticketPrice / created) * expired)
                    : undefined;
                return { name: name, amountOfSales: amountOfSales, created: created, used: used, expired: expired, type: type, groupName: groupName, breakageIncome: breakageIncome };
            });
            var resultArray_1 = [];
            ['선불액', '횟수권', '기간권', '시간권'].map(function (type) {
                refinedData_1.map(function (item) { return item.type === type && resultArray_1.push(item); });
            });
            return resultArray_1;
        }
        else {
            return [];
        }
    };
    var renderValueWithUnit = function (value, type) {
        var renderUnit = function () {
            switch (type) {
                case '기간권':
                    return '일';
                case '횟수권':
                    return '회';
                case '시간권':
                    return '시간';
                case '선불액':
                default:
                    return '원';
            }
        };
        return "".concat(KRWFomatWithoutWon({ value: value })).concat(renderUnit());
    };
    var renderBreakrageIncome = function (breakageIncome) {
        return breakageIncome !== undefined ? (React.createElement(TextComponent, { type: "body6", color: COLORS.staff3, children: "(\uB099\uC804 \uC218\uC785 ".concat(KRWFomatToString({ value: breakageIncome }), ")") })) : (React.createElement("span", null));
    };
    // FIXME: dataSource가 계속 undefined임..
    // const [, forceUpdate] = React.useReducer((x) => x + 1, 0);
    // React.useEffect(() => {
    //   forceUpdate();
    //   console.log('ㅇ리로드...', stat.data);
    // }, [stat.data]);
    console.log('stat', (_b = stat.data) === null || _b === void 0 ? void 0 : _b.tickets, (_d = (_c = stat.data) === null || _c === void 0 ? void 0 : _c.tickets) === null || _d === void 0 ? void 0 : _d.filter(function (item) { return item.ticketTemplateId == 3273; }));
    var dataSource = getData();
    return (React.createElement("div", null,
        React.createElement(XScrollableTable, { id: 'TABLE_ID_STAT_TICKET', resizable: { additionalColumnWidth: 0 }, pagination: false, rowKey: function (row, index) { return "".concat(index); }, loading: stat.isLoading, dataSource: dataSource, columns: [
                {
                    title: '구분',
                    dataIndex: 'groupName',
                    key: 'groupName',
                    fixed: 'left',
                    render: function (value, _, index) {
                        var obj = {
                            children: value,
                            props: {
                                rowSpan: 1,
                                colSpan: 1
                            }
                        };
                        // if (index === 0) {
                        //   obj.props.colSpan = 2;
                        // } else {
                        //   // obj.props.rowSpan = 0;
                        // }
                        // FIXME: dataSource가 계속 undefined임..
                        // if (index === 1) {
                        //   console.log('datadfadsf', dataSource, stat.data);
                        //   obj.props.rowSpan = dataSource.length - 1;
                        // }
                        return obj;
                    }
                },
                {
                    dataIndex: 'type',
                    key: 'type',
                    render: function (value, _, index) {
                        var obj = {
                            children: value,
                            props: {
                                rowSpan: 1,
                                colSpan: 1
                            }
                        };
                        return obj;
                    }
                },
                {
                    title: '이름',
                    key: 'name',
                    dataIndex: 'name'
                },
                {
                    title: '판매장수',
                    key: 'amountOfSales',
                    dataIndex: 'amountOfSales',
                    render: function (value) { return (isString(value) ? value : "".concat(value, "\uC7A5")); }
                },
                {
                    title: '충전양',
                    dataIndex: 'created',
                    key: 'created',
                    render: function (value, record) { return renderValueWithUnit(value, record.type); }
                },
                {
                    title: '이용량',
                    dataIndex: 'used',
                    key: 'used',
                    render: function (value, record) { return renderValueWithUnit(value, record.type); }
                },
                {
                    title: '기간 만료',
                    dataIndex: 'expired',
                    key: 'expired',
                    render: function (value, record) { return (React.createElement("div", null,
                        renderValueWithUnit(value, record.type),
                        renderBreakrageIncome(record.breakageIncome))); }
                },
                {
                    title: '잔여량',
                    dataIndex: 'rest',
                    key: 'rest',
                    render: function (_, record) { return renderValueWithUnit(record.created - record.used - record.expired, record.type); }
                },
                {
                    title: '이용률',
                    dataIndex: 'precent',
                    key: 'precent',
                    render: function (_, record) {
                        return "".concat(floor(((record.created - (record.created - record.used)) / record.created) * 100), "%");
                    }
                }
            ] }),
        React.createElement(Marginer, { height: 100 }),
        React.createElement(AlertComponent, { showIcon: true, type: "info", message: "\uC548\uB0B4", description: React.createElement("div", null,
                React.createElement(TextComponent, { children: "- \uC120\uBD88\uC561\uC740 \uAD6C\uB9E4 \uC989\uC2DC \uC120\uBD88 \uCDA9\uC804\uC561\uC73C\uB85C \uC804\uD658\uB429\uB2C8\uB2E4.", color: COLORS.gray2, type: "body5" }),
                React.createElement(TextComponent, { children: "- \uB099\uC804\uC218\uC785\uC740 \uC815\uC561 \uC0C1\uD488\uC744 \uAD6C\uB9E4\uD55C \uC18C\uBE44\uC790\uAC00 \uAE30\uBCF8 \uC81C\uACF5\uB7C9\uC744 \uC18C\uBAA8\uD558\uC9C0 \uC54A\uC544 \uBC1C\uC0DD\uD558\uB294 \uC0C1\uD488 \uC81C\uACF5\uC790\uC758 \uBD80\uAC00 \uC218\uC785\uC744 \uC758\uBBF8\uD569\uB2C8\uB2E4.", color: COLORS.gray2, type: "body5" }),
                React.createElement(TextComponent, { children: "- \uC120\uBD88 \uCDA9\uC804\uC561 \uBC0F \uC815\uAE30\uAD8C \uC774\uC6A9\uD1B5\uACC4\uB294 \uD305\uCEE4\uBDF0 \uC0AC\uC6A9\uC2DC\uC791\uC77C\uBD80\uD130 \uB204\uC801\uB41C \uC815\uBCF4\uB97C \uB098\uD0C0\uB0C5\uB2C8\uB2E4.", color: COLORS.gray2, type: "body5" })) })));
};
